/**
 * Shared useJsApiLoader options for OrderMapSelector.
 *
 * IMPORTANT: GoogleMap.jsx, PodsManagement.jsx and OrderModal.jsx already call
 * useJsApiLoader with conflicting options under other ids. This module uses a
 * dedicated id so OrderMapSelector does not become a fourth conflicting variant
 * of `google-map-script`. Do not change this id to match the existing callers
 * without migrating all of them together.
 *
 * Key rotation is out of scope (D3) — prefer env, fall back to the same browser
 * key the existing map components already ship.
 */
export const ORDER_MAP_LOADER_ID = 'google-map-order-selector';

export const ORDER_MAP_LIBRARIES = [];

export const getOrderMapLoaderOptions = () => ({
  id: ORDER_MAP_LOADER_ID,
  googleMapsApiKey:
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
    'AIzaSyBC28IfOmHnlcxvQo1sW9sduMvJ9jENTlE',
  // Empty libraries array — OrderMapSelector only needs core Map/Marker/InfoWindow.
  // Passing a different libraries list under a shared id is what breaks the loader.
  libraries: ORDER_MAP_LIBRARIES,
});
